import React from 'react';
import { BannerContainer, CoverImage } from './styles/HeaderBanner.styles';
import { getUploadsBaseUrl, normalizeUploadImageUrl } from '@/config/api.config';

interface HeaderBannerProps {
  children: React.ReactNode;
  className?: string;
  coverImage?: string;
}

export const HeaderBanner = React.forwardRef<HTMLDivElement, HeaderBannerProps>(
  ({ children, className, coverImage }, ref) => {
    const imageUrl = normalizeUploadImageUrl(
      coverImage
        ? coverImage.startsWith('http')
          ? coverImage
          : (() => {
              const baseUrl = getUploadsBaseUrl();
              const imagePath = coverImage.startsWith('/') ? coverImage : '/' + coverImage;
              return `${baseUrl}${imagePath}`;
            })()
        : undefined
    );

    return (
      <BannerContainer ref={ref} className={className} $hasImage={!!imageUrl}>
        {imageUrl && <CoverImage src={imageUrl} alt="Tournament cover" />}
        {children}
      </BannerContainer>
    );
  }
);

HeaderBanner.displayName = 'HeaderBanner';
